import { Navigate } from "react-router";

import AuthLayout from "../layouts/auth";
import MenuLayout from "../layouts/menu";
import ExternalLayout from "../layouts/external";

import * as MenuMiddleware from "../middleware/menu";
import * as AuthMiddleware from "../middleware/auth";

import menuRoutes from "./menu";
import externalRoutes from "./external";
import authRoutes from "./auth";

import NotFoundScreen from "../pages/error/not-found-screen";

const globalRoutes = [
  {
    path: "",
    element: (
      <AuthMiddleware.CheckAuthenticatedUser>
        <MenuMiddleware.ProvideMenuData>
          <MenuLayout />
        </MenuMiddleware.ProvideMenuData>
      </AuthMiddleware.CheckAuthenticatedUser>
    ),
    children: menuRoutes,
  },
  { path: "auth", element: <AuthLayout />, children: authRoutes },
  { path: "encuestas", element: <ExternalLayout />, children: externalRoutes },
  { path: "404", element: <NotFoundScreen /> },
  { path: "*", element: <Navigate to="/404" /> },
];

export default globalRoutes;
